import type { ClubTheme } from './themes';

interface ClubBadgeProps {
  role: string;
  theme: ClubTheme;
}

const ROLE_LABELS: Record<string, string> = {
  admin: 'Admin',
  moderator: 'Moderator',
  coach: 'Coach',
  member: 'Member',
};

export default function ClubBadge({ role, theme }: ClubBadgeProps) {
  const label = ROLE_LABELS[role] || role;
  const isMod = role === 'moderator' || role === 'admin' || role === 'coach';

  return (
    <span
      className="inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider"
      style={{
        backgroundColor: isMod ? theme.colors.primary : theme.colors.surface,
        color: isMod ? theme.colors.bg : theme.colors.muted,
        border: isMod ? 'none' : `1px solid ${theme.colors.muted}40`,
      }}
    >
      {label}
    </span>
  );
}
